export default __webpack_public_path__ + "static/media/logo.d6908b1d.svg";